import { Link } from "react-router-dom";

const linkGroups = [
  {
    title: "赛事分类",
    links: [
      { label: "篮球直播", to: "/category/basketball" },
      { label: "足球直播", to: "/category/football" },
      { label: "电竞直播", to: "/category/esports" },
      { label: "赛程与回放", to: "/schedule" },
    ],
  },
  {
    title: "关于平台",
    links: [
      { label: "关于我们", to: "/about" },
      { label: "联系我们", to: "/contact" },
      { label: "赛事搜索", to: "/search" },
    ],
  },
];

const friendLinks = ["体育资讯站", "篮球数据网", "足球评论", "电竞快讯", "赛程日历"];

export default function Footer() {
  return (
    <footer className="mt-16 bg-primary-950">
      <div className="mx-auto grid grid-cols-1 gap-10 px-4 py-12 md:grid-cols-2 md:px-6 lg:grid-cols-4 lg:py-16">
        <div className="lg:col-span-2">
          <div className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 font-heading text-lg font-extrabold text-background-50">
              J
            </span>
            <span className="font-heading text-lg font-extrabold text-foreground-950">
              jrs直播
            </span>
          </div>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-500">
            jrs直播是聚焦篮球、足球、电竞的体育赛事直播平台，聚合多项目赛事实时动态，
            支持多赛事并行观看与快速检索，助你不错过任何精彩瞬间。
          </p>
          <div className="mt-5 flex items-center gap-3">
            {["ri-wechat-line", "ri-weibo-line", "ri-bilibili-line", "ri-mail-line"].map(
              (icon) => (
                <span
                  key={icon}
                  className="flex h-9 w-9 items-center justify-center rounded-lg bg-background-50/5 text-foreground-600 transition-colors hover:bg-primary-500/20 hover:text-primary-400"
                >
                  <i className={`${icon} text-base`} />
                </span>
              ),
            )}
          </div>
        </div>

        {linkGroups.map((group) => (
          <div key={group.title}>
            <h3 className="font-heading text-sm font-semibold text-foreground-900">
              {group.title}
            </h3>
            <ul className="mt-4 space-y-2.5">
              {group.links.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-foreground-500 transition-colors hover:text-primary-400 whitespace-nowrap"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="border-t border-background-50/10">
        <div className="mx-auto flex flex-col gap-4 px-4 py-6 md:flex-row md:items-center md:justify-between md:px-6">
          <p className="text-xs text-foreground-500">
            © 2026 jrs直播 · 本站为演示展示平台，所有赛事数据均为示例内容
          </p>
          <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
            <span className="text-xs text-foreground-500">友情链接：</span>
            {friendLinks.map((link) => (
              <span
                key={link}
                className="text-xs text-foreground-500 transition-colors hover:text-primary-400 cursor-pointer whitespace-nowrap"
              >
                {link}
              </span>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}